export const INITIAL_VALUES = {
	country_code: '+966',
	phone: '',
	password: ''
};

export const validate = (t) => (values) => {
	let errors = {};

	const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

	if (!values.email) {
		errors.email = t('register.validation.email_required');
	} else if (!emailRegex.test(values.email)) {
		errors.email = t('register.validation.email_invalid');
	}

	if (!values.password) {
		errors.password = t('register.validation.password_required');
	}

	if (!values.birth_date) {
		errors.birth_date = t('register.validation.birth_date_required');
	}

	if (!values.id_number) {
		errors.id_number = t('register.validation.id_number_required');
	}

	if (!values.license_expire_date) {
		errors.license_expire_date = t('register.validation.license_expire_date_required');
	}

	if (!values.phone) {
		errors.phone = t('register.validation.id_phone_required');
	}

	return errors;
};
